import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
import { Button } from './Button';
import { checkoutUrl, ctaLabel } from '../data/offer';
import { trackCheckout } from '../utils/pixel';
export function Hero() {
  return <section className="relative pt-6 sm:pt-10 pb-12 px-4 overflow-hidden" data-id="element-129" data-mp="9ipchchyjg0n">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-gold-dark/20 via-black to-black -z-10" data-id="element-130" data-mp="4n9ymkjy9k48" />
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center" data-id="element-131" data-mp="xannrwhepbds">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="w-full" data-id="element-132" data-mp="x8jo5qqjiyjb">
          <div className="inline-block px-3 py-1 rounded-full border border-gold/30 bg-gold/10 text-gold-light font-medium text-[10px] sm:text-sm tracking-wide whitespace-nowrap mb-4 sm:mb-6" data-id="element-133" data-mp="nczsn5fw21v3">
            📚 Prof d&apos;Espagnol Prêt
          </div>
          <h1 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-4 sm:mb-6" data-id="element-134" data-mp="384jt6yzotjsx">
            Résous une année entière de cours d&apos;espagnol{' '}
            <span className="text-gold-gradient" data-id="element-135" data-mp="3o6u87dib4xei">en seulement 5 MINUTES</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="relative w-full max-w-[320px] sm:max-w-xl md:max-w-3xl mb-4 sm:mb-6" data-id="element-136" data-mp="39cfjqxfz4vsg">
          <div className="absolute inset-0 bg-gold/20 blur-[80px] rounded-full" data-id="element-137" data-mp="359javyg8ke1p" />
          <img src="https://cdn.magicpatterns.com/uploads/k9YN7Az3awT4ZRqiJ9N3Yx/Diseno_sin_titulo_(59).png" alt="Prof d'Espagnol Prêt — 6 volumes complets, Spanish 1 et Spanish 2 et 5 bonus guides" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-138" data-mp="2qkmu9d045sph" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="w-full" data-id="element-139" data-mp="2lk8u0h4r7n20">
          <p className="text-sm sm:text-lg md:text-xl text-gray-300 leading-snug max-w-2xl mx-auto mb-5 sm:mb-7" data-id="element-140" data-mp="nbba6qtxtx1l">
            Le système pédagogique 8 en 1 pour professeurs d&apos;espagnol francophones — la bibliothèque complète pour Spanish 1
            et Spanish 2, prête à utiliser dès aujourd&apos;hui.
          </p>
          <div className="flex justify-center mb-5 sm:mb-7" data-id="element-141" data-mp="1b15o7bpztrnf">
            <Button href={checkoutUrl} target="_blank" onLinkClick={trackCheckout} className="text-sm sm:text-lg md:text-xl py-3 sm:py-5 px-5 sm:px-10 whitespace-nowrap" data-id="element-142" data-mp="1ayjh1d70le5q">
              {ctaLabel}
            </Button>
          </div>
          <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-gray-400" data-id="element-143" data-mp="x3h6gcr830ml">
            <div className="flex items-center gap-1.5" data-id="element-144" data-mp="3hrd9kw2ghc0f">
              <CheckCircle size={14} className="text-gold" data-id="element-145" data-mp="3hpsff7k1zv33" />
              <span data-id="element-146" data-mp="1x9ukuaytndnf">Système complet 8 en 1</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-147" data-mp="1x7hwng2h071x">
              <CheckCircle size={14} className="text-gold" data-id="element-148" data-mp="21bplrecubp0o" />
              <span data-id="element-149" data-mp="26a98hgz9d4u3">5 bonus inclus</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-150" data-mp="268odxrcy1lw8">
              <CheckCircle size={14} className="text-gold" data-id="element-151" data-mp="2b0zf0xjf7dqd" />
              <span data-id="element-152" data-mp="2b2kaqqhh12pt">Accès immédiat</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}